import React, { useContext, useEffect } from "react";
import Form from "../../Helpers/Form/Form";
import { popupcontext } from "../../../context/Popupscontext";
import { Offcanvas } from "react-bootstrap";
import FormHeader from "../../Helpers/Form/FormParts/FormHeader";
import trans from "../../../utils";
import InspectionRequestBody from "./InspectionRequestBody";

export default function InspectionRequestForm({ preselectedLocation = null }) {
	const { form, isEditing, currentIRId, handleClose } = useContext(popupcontext);

	// ✅ Clear preselectedLocation when form closes
	useEffect(() => {
		if (!form && preselectedLocation) {
			// Location will be cleared by parent component
		}
	}, [form, preselectedLocation]);

	return (
		<>
			<Form show={form}>
				<Offcanvas.Header>
					<FormHeader
						title={
							isEditing
								? trans("Edit Inspection Request")
								: trans("Add Inspection Request")
						}
					/>
				</Offcanvas.Header>
				<div className="H-line"></div>
				<InspectionRequestBody preselectedLocation={preselectedLocation} />
			</Form>
		</>
	);
}
